import React from 'react';

import DeveloperModeIcon from '@material-ui/icons/DeveloperMode';

import {
  PERMISSAO_TELA_FEATURES_LISTAR,
  PERMISSAO_TELA_SOFTWARES_LISTAR,
} from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';

const SubMenuDevelopment = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  permissoes,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Development"
    icon={<DeveloperModeIcon className={classes.icon} />}
  >
    {permissoes[PERMISSAO_TELA_FEATURES_LISTAR] && hasResource('features')}
    {permissoes[PERMISSAO_TELA_SOFTWARES_LISTAR] && hasResource('softwares')}
  </SubMenu>
);

export default SubMenuDevelopment;
